import React, { useState, useEffect, useRef } from 'react'
import { Accordion, AccordionItem, AccordionItemButton, AccordionItemHeading, AccordionItemPanel, AccordionItemState } from 'react-accessible-accordion';
import _ from 'lodash'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { fetchTaskList } from '../../../Components/action/common'
import moment from 'moment';
import { verifyRepeatedTaskAsPerTodoist } from '../../../Components/action/utilities';
import TaskList from '../../Tasks/TaskList';
import TodoList from '../../../Components/ChatGPT/TodoList';
import { setActiveTaskList } from '../../../redux/slices/AiTasks';

const PlannedTasks = ({onCreateTodos, id}) => {
    const [tasks, setTasks] = useState([])
    const [taskList, setTaskList] = useState([])
    const dispatch = useDispatch()
    const wrapperRef = useRef(null)

    useEffect(() => {
        dispatch(setActiveTaskList(null));
        // const bound = wrapperRef.current.getBoundingClientRect()
        // wrapperRef.current.style.height = window.innerHeight - bound.top + 'px'
    }, [])

    useEffect(() => {
        const fetchTasks = async () => {
            const response = await fetchTaskList({status: 0});
            dispatch(setTaskList(response?.data?.responseData ?? []));
        }
        fetchTasks();
    }, [])

    useEffect(() => {
        if(!taskList) return;

        const today = moment().startOf('day').toISOString();
        
        // Tasks
        const tasks = _.orderBy(taskList.map(item => {
            if(item?.repeat?.rule){
                const result = verifyRepeatedTaskAsPerTodoist(item, moment().toISOString(), moment(item?.date).startOf('date').toISOString() == moment().startOf('date').toISOString())
                return result ? item : false;
            }else{
                const result = item.status == 0 && item.date !== null && item.date == today;
                return result ? item : false;
            }
        }).filter(item => item !== false), ['date'], ['asc']);

        // Set tasks
        setTasks(tasks)

    }, [taskList])

    return (
        <TodoList defaultTasks={tasks} id={id} onCreateTodos={onCreateTodos} defaultOpen={true} />
    )
}

export default PlannedTasks